import styled from "styled-components";
import { MediatorDataContainer } from "../../common/mediator-styles";

export const ForeignersHealthMediatorContainer = styled(MediatorDataContainer)``;
